import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Registration} from 'src/app/models/registration.model';
import {RegistrationService} from 'src/app/services/registration_service.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { MatFormField, MatLabel, MatError, MatSelect, MatOption, MatHint } from "@angular/material/select";
import { MatDatepickerToggle, MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  imports: [MatFormField, MatInputModule, MatButtonModule, MatLabel, MatError, MatSelect, MatOption, MatDatepickerToggle, MatDatepicker, MatHint, MatProgressBar, ReactiveFormsModule, MatDatepickerModule, FormsModule],
})
export class RegistrationComponent implements OnInit {

  properEmail: boolean = false;

  registrationForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    emailAddress: new FormControl('', [Validators.required, Validators.email]),
    address: new FormControl('', Validators.required),
    city: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    zipCode: new FormControl('', [Validators.required, Validators.pattern('(^\\d{5}$)|(^\\d{9}$)|(^\\d{5}-\\d{4}$)')]),
    dateOfBirth: new FormControl('', Validators.required),
    primaryPhoneNumber: new FormControl('', [Validators.required, Validators.pattern(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)]),
    secondaryPhoneNumber: new FormControl('', Validators.pattern(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)),
  });

  states: string[] = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 
                      'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 
                      'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 
                      'LA', 'ME', 'MD', 'MA', 'MI', 'MN',
                      'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
                      'NJ', 'NM', 'NY', 'NC', 'ND', 'OH',
                      'OK', 'OR', 'PA', 'RI', 'SC', 'SD',
                      'TN', 'TX', 'UT', 'VT', 'VA', 'WA',
                      'WV', 'WI', 'WY']

  registrationImage = "../../../assets/images/upper5.png";

  loading = false;
  saving = false;
  errorMessage: string | null = null;

  constructor(
    private router: Router,
    private registrationService: RegistrationService,
    private tokenStorage: TokenStorageService,
  ) {}

  ngOnInit(): void {
    this.tokenStorage.clearToken();
  }

  selectState(e: any): void {
    this.registrationForm.controls.state.setValue(e.target.value, {
      onlySelf: true
    }); 
  }

  get formControls(): { [p: string]: AbstractControl } {
    return this.registrationForm.controls;
  }

  get formValues(): any {
    return this.registrationForm.value;
  }

  
  checkProperEmail(): void {
    this.properEmail = false;
    if(this.registrationForm.controls.emailAddress.value?.includes('.')){
      this.properEmail = true;
    }
  }


  onSubmit(): void {
    this.saving = true;

    const registrationModel = new Registration(
      this.formValues.firstName,
      this.formValues.lastName,
      this.formValues.emailAddress,
      this.formValues.address,
      this.formValues.city,
      this.formValues.state,
      this.formValues.zipCode,
      this.formValues.primaryPhoneNumber,
      this.formValues.secondaryPhoneNumber,
      this.formValues.dateOfBirth.toISOString(),
    );

    this.errorMessage = null;

    this.registrationService
      .post(['Registration'], registrationModel).subscribe(
      (_) => {
        this.saving = false;
        this.router.navigate(['registration-confirmation']);
      },
      (error) => {
        this.errorMessage = error;
        this.saving = false;
      });
  }
}

